// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_app_features_auth_auth_module_ts":"9dd2527a496e1269","src_app_features_plans_plans_module_ts":"7dcaa3d856262250","node_modules_canvas-confetti_dist_confetti_module_mjs":"80578430f2503f8f"}[chunkId] + ".js";
};